import get from 'lodash/get';
import fdpHelper from 'utils/FDPHelper';
export default function getAbValueAction(experimentName, defaultValue) {
    return (_dispatch, getState) => {
        const abExperiments = getState().abExperiments;
        let returnValue = get(abExperiments, experimentName);
        // used specific checks for null and undefined. `returnValue.value` can be false;
        if (!returnValue || returnValue.value === null || typeof returnValue.value === 'undefined') {
            return defaultValue;
        }
        // 'a' stands for array of abIds
        fdpHelper.trackEvent({
            en: 'ABV2',
            a: new Array(returnValue.abId)
        });
        const enableABV2Changes = get(getState().config, 'data.globalConfig.enableABV2Changes', false);
        // only track `ABE` fdp event, if `enableABV2Changes` config flag is set
        if (enableABV2Changes) {
            fdpHelper.trackEvent({
                en: 'ABE',
                abi: [{ abId: returnValue.abId, expId: returnValue.expId }]
            });
        }
        return returnValue.value;
    };
}
